import React, { useEffect, useState } from 'react';
import BCIF_Container from '../BCIF_Container';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import common from '~/common';
import Actions_Wind from '~/Actions_Wind';
import DailyDialog from './DailyDialog';

const Card = ({ title, onClick = () => {} }) => {
  const [over, setOver] = useState(false);
  return (
    <div
      style={{
        backgroundColor: over ? '#d8d8d8' : 'white',
        height: 99,
        width: 220,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)',
        borderRadius: 8,
        marginLeft: 24,
        marginRight: 24,
        cursor: 'pointer',
      }}
      onClick={onClick}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
    >
      <div style={{ color: '#4CC2CA', fontWeight: 700, fontSize: 32 }}>{title}</div>
      <div style={{ color: '#247690', fontWeight: 700, fontSize: 18 }}>風機點位工進表</div>
    </div>
  );
};

const App = ({ windId }) => {
  const [displayDaily, setDisplayDaily] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => { if (windId)Actions_Wind.getWindIdDetail(dispatch, { id: windId }); }, []);
  const WindIdDetail = useSelector(state => state.data.WindIdDetail || {});
  const PathAry = useSelector(state => state.data.PathAry || []);
  const isManage = useSelector(state => state.isManage);
  const history = useHistory();
  const func = {
    月: () => {
      if (isManage) {
        if (PathAry.indexOf('work_progress') > -1) {
          history.push(`${common.rootPath}/Manage/Main/data/works_progress/work_progress`);
        } else alert('您未獲得訪問[工程進度]頁面的權限');
      } else history.push(`${common.rootPath}/Gis/data/singWind/perMonth`);
    },
    週: () => {
      if (isManage) {
        if (PathAry.indexOf('work_progress') > -1) {
          history.push(`${common.rootPath}/Manage/Main/data/works_progress/work_progress`);
        } else alert('您未獲得訪問[工程進度]頁面的權限');
      } else history.push(`${common.rootPath}/Gis/data/singWind/perWeek`);
    },
    日: () => {
      if (isManage) {
        if (PathAry.indexOf('work_progress') > -1) {
          history.push(`${common.rootPath}/Manage/Main/data/works_progress/daily_progress`);
        } else alert('您未獲得訪問[工程進度]頁面的權限');
      } else setDisplayDaily(true);
    },
  };
  const cardList = () => {
    switch (WindIdDetail.schedule_status) {
    case '1':return [{ title: '月' }];
    case '2':return [{ title: '月' }, { title: '週' }];
    case '3':return [{ title: '月' }, { title: '週' }, { title: '日' }];
    default:return [];
    }
  };
  const data = cardList();
  return data.length === 0
    ? null
    : (
      <BCIF_Container title='目前工進' defaultOpen={false}>
        <div style={{ marginTop: 50, marginBottom: 50, display: 'flex', flexShrink: 0, justifyContent: 'center' }}>
          {data.map((o, i) => <Card key={i} {...o} onClick={func[o.title]} />)}
        </div>
        <DailyDialog {...{ windId, displayDaily, setDisplayDaily }} />
      </BCIF_Container>
    );
};

export default App;
